import { Helper } from '../Helper';
export class ThrowCompletionHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitLine(node);
        sb.emitPushString(node, 'trace');
        sb.emitPushInt(node, 2);
        sb.emitOp(node, 'PACK');
        sb.emitSysCall(node, 'Neo.Runtime.Notify');
        sb.emitHelper(node, options, sb.helpers.throwCompletionBase);
    }
}

//# sourceMappingURL=ThrowCompletionHelper.js.map
